import React, { useState } from 'react';
import Upvote from './upvote';
import Downvote from './downvote';
import LoginPopup from './LoginPopup';
import { useAuth0 } from '@auth0/auth0-react';
import LogoutButton from './LogoutButton';
import './styles/Widget.css';

function Widget() {
	// Handle Popup
	const [ isOpen, setIsOpen ] = useState(false);
	const togglePopup = () => {
		setIsOpen(!isOpen);
	};
	const { loginWithRedirect, isAuthenticated } = useAuth0();
	return (
		<div className="Widget__container">
			<div className="Widget__upvoteDownvoteContainer">
				<h1>Thumbs</h1>
				<div className="Widget__buttons" onClick={togglePopup}>
					<Upvote />
					<Downvote />
				</div>
			</div>
			{isOpen &&
			!isAuthenticated && (
				<div className="Widget__popup">
					<LoginPopup handleClose={togglePopup} />
				</div>
			)}

			<LogoutButton />
		</div>
	);
}

export default Widget;
